import m from "../../es2015/lang/ru_RU";
window.am4lang_ru_RU = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ru_RU.js
// module id = null
// module chunks = 